<div
  class="group flex items-center justify-between border-b-2 border-neutral-95 p-4 transition hover:bg-neutral-95">
  <div>
    <h4 class="text-sm font-bold">
      {{ workplace()?.name }}
    </h4>
    @if (workplace()?.address) {
      <p class="mt-1 text-xs text-gray-500">
        @if (workplace()?.address?.line1) {
          <span>{{ workplace()?.address?.line1 }}</span>
        }
        @if (workplace()?.address?.line2) {
          <span class="ms-1">{{ workplace()?.address?.line2 }}</span>
        }
        @if (workplace()?.address?.postalCode) {
          <span class="ms-1">{{ workplace()?.address?.postalCode }}.</span>
        }
        @if (workplace()?.address?.city) {
          <span class="ms-1">{{ workplace()?.address?.city }}.</span>
        }
        @if (workplace()?.address?.countryName) {
          <span class="ms-1">{{ workplace()?.address?.countryName }}.</span>
        }
      </p>
    }
  </div>
  <button
    *qaroniRoleAccessPermission
    mat-icon-button
    color="blue"
    matTooltip="Editar"
    i18n-matTooltip
    (click)="goToWorkplaceUpdate()">
    <mat-icon fontIcon="edit" />
  </button>
</div>
